import {
    Component,
    ElementRef,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { RowLinkedModel } from '../../../../models/linked-models/row-linked-model';
import { DisplayComponentEventBusService } from '../../shared/display-event-bus/display-component-event-bus.service';
import {
    CustomOnChanges,
    CustomSimpleChanges
} from '../../../../utils/angular-extensions';

@Component({
    selector: 'lib-row',
    templateUrl: './row.component.html',
    styles: [`
        .row {
            position: relative;
        }

        .container {
            display: block;
        }

        .outer {
            margin-left: auto;
            margin-right: auto;
        }

        .inner {
            display: block;
            margin-left: auto;
            margin-right: auto;
            box-sizing: border-box;
        }
    `],
})
export class RowComponent
    implements OnInit,
        CustomOnChanges,
        OnDestroy {
    @Input() rowModel: RowLinkedModel;
    @Input() position: number;
    @Input() isResponsive: boolean;

    constructor(
        private elementRef: ElementRef,
        public displayComponentEventService: DisplayComponentEventBusService) {
    }

    ngOnInit(): void {
        this.displayComponentEventService.create(
            this.rowModel,
            this.position,
            this.elementRef)
    }

    ngOnChanges(changes: CustomSimpleChanges<this>): void {
        if (changes.position) {
            this.displayComponentEventService.change(
                this.rowModel,
                this.position,
                this.elementRef);
        }
    }

    ngOnDestroy(): void {
        this.displayComponentEventService.destroy(this.rowModel);
    }
}
